import gql from 'graphql-tag'
import {useQuery} from 'react-apollo'
import {Client} from '../../../../../graphql/types'
import {PAMM_OFFER_TREE_FIELDS} from '../../../../PammOffersTree/pammOfferFragment'

/**
 * Fetches a Money Manager's PAMM offers for the hierarchical tree view.
 *
 * Uses the GraphQL `pammOffers` field (rather than the REST endpoint the page used
 * previously) because it returns the parsed `agentChain` the tree needs to rebuild the
 * offer hierarchy. `pammOffers` returns the manager's whole network, so the flat list can
 * be assembled into a tree on the client.
 */
const ACCOUNTS_WITH_PAMM_OFFERS = gql`
  query AccountsWithPammManagerOffers {
    viewer {
      ... on Client {
        id
        accounts(hidden: false, rejected: false) {
          ... on BaseAccount {
            id
            pammOffers {
              ...PammOfferTreeFields
            }
          }
        }
      }
    }
  }
  ${PAMM_OFFER_TREE_FIELDS}
`

const isNotNil = <T>(value: T): value is NonNullable<T> => value !== null && typeof value !== 'undefined'

export const usePammManagerOffers = (managerAccountId: number) => {
  const {loading, data, error} = useQuery<{viewer: Client}>(ACCOUNTS_WITH_PAMM_OFFERS)

  const managerAccount = (data?.viewer?.accounts ?? []).find(
    (account) => account?.id === managerAccountId,
  )
  const offers = (managerAccount?.pammOffers ?? []).filter(isNotNil)

  return {error, loading, offers}
}
